module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login"
    }
  }, [_c('h2', [_vm._v("核销中心")]), _vm._v(" "), _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "field name"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'user.png'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('van-field', {
    attrs: {
      "icon": "clear",
      "placeholder": "用户名"
    },
    on: {
      "click-icon": function($event) {
        _vm.username = ''
      }
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "field password"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'password.png'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('van-field', {
    attrs: {
      "type": "password",
      "icon": "clear",
      "placeholder": "密码"
    },
    on: {
      "click-icon": function($event) {
        _vm.password = ''
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)]), _vm._v(" "), _c('a', {
    staticClass: "loginBtn",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("立即登陆")]), _vm._v(" "), _c('div', {
    staticClass: "keep"
  }, [_c('van-checkbox', {
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("记住密码")])], 1)]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', [_vm._v("使用说明：")]), _vm._v(" "), _c('p', [_vm._v("主办方在后台设置核销管理员用户名、密码，核销管理员在该页面进行登录。登录完成后即可扫码进行核销。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cef315d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/exchange/login.vue
// module id = 495
// module chunks = 0